import { render, staticRenderFns } from "./staticPage.vue?vue&type=template&id=07159439&scoped=true&"
import script from "./staticPage.vue?vue&type=script&lang=js&"
export * from "./staticPage.vue?vue&type=script&lang=js&"
import style0 from "./staticPage.vue?vue&type=style&index=0&id=07159439&scoped=true&lang=css&"
import style1 from "./staticPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07159439",
  null
  
)

export default component.exports